module.exports = __webpack_public_path__ + "static/media/Warm.7d1ffbea.svg";